import { api } from './api';

export interface Approval {
  id: string;
  type: string;            // FeeDiscount | Scholarship | ...
  status: string;          // Pending | Approved | Rejected | Withdrawn
  subjectId: string;
  subjectLabel: string;
  amountPaise: number;
  requestedInName: string | null;
  reason: string | null;
  detail: string | null;
  requestedByUserId: string;
  requestedAt: string;
  decidedByUserId: string | null;
  decidedAt: string | null;
  decisionSource: string | null;   // Human | AutoWithinCap
  decisionNote: string | null;
  isApplied: boolean;
}

export interface PagedApprovals {
  items: Approval[];
  total: number;
  skip: number;
  take: number;
}

export interface DiscountAuthority {
  role: string;
  maxSelfApproveBps: number;    // 500 = 5%
  maxSelfApprovePaise: number;  // 0 = no absolute ceiling
}

export const approvalsApi = {
  // finance desk raises a fee discount, in a named person's name
  raiseFeeDiscount: (b: {
    invoiceId: string;
    discountPaise: number;
    requestedInName: string;
    reason?: string | null;
  }) => api.post<Approval>('/api/approvals/fee-discount', b),

  mine: () => api.get<Approval[]>('/api/approvals/mine'),
  withdraw: (id: string) => api.post<Approval>(`/api/approvals/${id}/withdraw`),

  // management inbox
  list: (opts?: { type?: string; status?: string; skip?: number; take?: number }) => {
    const q = new URLSearchParams();
    if (opts?.type) q.set('type', opts.type);
    if (opts?.status) q.set('status', opts.status);
    if (opts?.skip != null) q.set('skip', String(opts.skip));
    if (opts?.take != null) q.set('take', String(opts.take));
    const qs = q.toString();
    return api.get<PagedApprovals>(`/api/approvals/${qs ? `?${qs}` : ''}`);
  },
  decide: (id: string, decision: 'approve' | 'reject', note?: string) =>
    api.post<Approval>(`/api/approvals/${id}/decide`, { decision, note: note ?? null }),

  // per-role discount caps (config-as-data)
  authorities: () => api.get<DiscountAuthority[]>('/api/approvals/authorities'),
  setAuthority: (b: DiscountAuthority) => api.put<DiscountAuthority>('/api/approvals/authorities', b),
};
